package com.clany.backoffice.model

import kotlinx.serialization.Serializable

@Serializable
data class SubscriptionWebhookEventResponse(
    val id: String,
    val appUserId: String,
    val productId: String?,
    val eventTimestampMs: Long,
    val purchasedAtMs: Long?,
    val expirationAtMs: Long?,
    val environment: String?,
    val countryCode: String?,
    val store: String?,
    val type: String?,
    val cancelReason: String?,
    val receivedAt: String
)
